import { SearchOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const SearchBtn = ({
  displayText = true,
  text = null,
  ...restProps
}) => {
  return (
    <Button color="cyan" variant="solid" {...restProps}>
      <SearchOutlined />
      {displayText && (text == null ? "Buscar" : text)}
    </Button>
  );
};
